/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SupportChatStatusRequest} from '@cash-web/protos/squareup/cash/supportal/app.pb'
import {SupportChatStatusResponse} from '@cash-web/protos/squareup/cash/supportal/app.pb'


export const supportChatStatus = (request: SupportChatStatusRequest, options?: CashRequestOptions) => post<SupportChatStatusRequest, SupportChatStatusResponse>("/2.0/cash/support-chat-status", request, {...options, rejectOnError: true })